import FormField from "../Input/FormField";
import Button from "../Input/Button";
import { useFormik } from "formik";
import Context from "../../../context";
import { useContext } from "react";
import axios from "axios";
import { API_URL } from "../../data/constants";

export default function SignUpPage() {
  const { contextState, setContextState } = useContext(Context);

  function validate(values) {
    const errors = {};
    if (!values.email) {
      errors.email = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.customerID) errors.customerID = "Required";

    if (!values.taxID) errors.taxID = "Required";
    else if (values.taxID.length > 4) {
      errors.taxID = "Please enter only the last 4 of your Tax ID";
    }

    if (!values.password1) {
      errors.password1 = "Required";
    } else if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i.test(
        values.password1
      )
    ) {
      errors.password1 =
        "Minimum 8 characters, one number, one upper case letter, and one special character required";
    }

    if (values.password2 !== values.password1) {
      errors.password2 = "Passwords must match";
    }
    return errors;
  }

  const signUpForm = useFormik({
    initialValues: {
      email: "",
      customerID: "",
      taxID: "",
      password1: "",
      password2: "",
    },
    validate,
    onSubmit: (values) => {
      axios
        .post(API_URL + "/Profiles", {
          email: values.email,
          password: values.password2,
          customerNumber: values.customerID,
          federalTaxId: values.taxID,
        })
        .then((res) => {
          let data = {
            type: "message",
            title: res.data.title,
            content: res.data.message,
          };
          setContextState({ ...contextState, modal: data });
          //setContextState({ ...contextState, loginActivePage: "login" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  return (
    <>
      <h3 className="login-header">Create New Profile</h3>
      <form className="login-form" onSubmit={signUpForm.handleSubmit}>
        <FormField
          field="email"
          type="email"
          name="Email (User ID)"
          form={signUpForm}
        />
        <FormField
          field="customerID"
          type="text"
          name="Customer Number"
          form={signUpForm}
        />
        <FormField
          field="taxID"
          type="text"
          name="Federal Tax ID (Last 4)"
          form={signUpForm}
        />
        <FormField
          field="password1"
          type="password"
          name="Create Password"
          form={signUpForm}
        />
        <FormField
          field="password2"
          type="password"
          name="Re-enter Password"
          form={signUpForm}
        />
        <Button
          className="btn btn-fluid btn--blue btn--bordered"
          type="submit"
          disabled={!(signUpForm.dirty && signUpForm.isValid)}
          text="Create Profile"
        />
      </form>
      <span
        className="login-link"
        onClick={() => {
          setContextState({ ...contextState, loginActivePage: "login" });
        }}>
        Back to Login
      </span>
    </>
  );
}
